import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, ButtonSelect, Menu, Typography } from '@saviynt/design-system';

import { pageMaps } from '../../../../constants/obNextGenConstants';
import { useLocalization } from '../../../../hooks';
import initialIntegrationOptions from '../../constants/integrationsConstants';
import type { Option } from '../../data-layer/types';

import './IntegrationsHeader.css';

/**
 * IntegrationsHeader
 */
export default function IntegrationsHeader() {
  const history = useHistory();
  const formatMessage = useLocalization();

  const [integrationOptions, setIntegrationOptions] = useState<Option[]>(
    initialIntegrationOptions
  );

  const handleAddIntegration = (selectedOption: Option) => {
    setIntegrationOptions((prevOptions) =>
      prevOptions.map((option) => ({
        ...option,
        isChecked: option.value === selectedOption.value,
      }))
    );
    const matchedPage = pageMaps.find(
      (page) => page.value === selectedOption.value
    );

    if (matchedPage) {
      history.push(matchedPage.route);
    }
  };

  return (
    <Box className='Integrations-heading' dataTestId='integrations-header'>
      <Typography
        color='--color-foreground-neutral-bold'
        kind='h1'
        dataTestId='integrations-title'>
        {formatMessage('INTEGRATIONS.DASHBOARD.HEADER.TITLE', 'Integrations')}
      </Typography>
      <Box
        className='Integrations-heading-viewToggleGroup'
        dataTestId='view-toggle-group'>
        <Menu
          options={integrationOptions}
          onChange={handleAddIntegration}
          trigger={
            <ButtonSelect
              kind='rectangle'
              label={formatMessage(
                'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION',
                'Add Integration'
              )}
              size='medium'
            />
          }
          size='medium'
          dataTestId='add-integration-button'
          className='IntegrationsPageToolbox-buttonAddIntegration'
        />
      </Box>
    </Box>
  );
}
